import React, { Fragment, useEffect, useMemo, useState } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { GetIframeUrl, SetActiveId, GetMarketInfo } from '../../common/actions/sportsAction';
import { sortMarkets, isEmpty, dateFormation, fixedNumber, fixBetGameData, getMatchInfo, toastr, fixBetsData, onErrorImg } from '../../common/cores';
import Swipbox from './Swipbox';
import { sportIds } from '../../utils/names';
import { resource_url } from '../../common/cores/keys';
import { AddOneBet, RemoveOneBet } from '../../common/actions/betAction';


const locationUrl = resource_url + "/images/locations/";

const Match = (props) => {

    let { type, gamelist, onShoMawrket } = props;
    const { bettedItems, marketNameList, eventpartNameList, showLeague, pageInfo, sportsMarketInfo, onInteriorShowMarket, keyIndex, interiorShowMarket, marketSetting, baselineSetting } = props;
    const { sportPrematchRateSetting, sportLiveRateSetting, esportPrematchRateSetting, esportLiveRateSetting } = baselineSetting;

    const [showMarkets, setShowMarkets] = useState(false);
    let sportId = type !== "esports" ? gamelist.Fixture.League.sport.Id : gamelist.Fixture.League.sport.oddsId;

    const rateValue = useMemo(() => {
        let sportsRateIndex = -1;
        let sportRate = {}
        if (pageInfo.RoomType === "sport") {
            if (pageInfo.gameType === "live") {
                sportsRateIndex = isEmpty(sportLiveRateSetting) ? -1 : sportLiveRateSetting.findIndex(setting => setting.sportId == sportId);
                sportRate = sportsRateIndex > -1 ? sportLiveRateSetting[sportsRateIndex] : {};
            }
            else {
                sportsRateIndex = isEmpty(sportPrematchRateSetting) ? -1 : sportPrematchRateSetting.findIndex(setting => setting.sportId == sportId);
                sportRate = sportsRateIndex > -1 ? sportPrematchRateSetting[sportsRateIndex] : {};
            }


            if (!isEmpty(sportRate) && sportRate.status && !isEmpty(sportRate.min) && !isEmpty(sportRate.max)) {
                return {
                    min: Number(sportRate.min),
                    max: Number(sportRate.max),
                }
            }
            else {
                return {}
            }
        }
        else {
            if (pageInfo.gameType === "live") {
                sportsRateIndex = isEmpty(esportLiveRateSetting) ? -1 : esportLiveRateSetting.findIndex(setting => setting.sportId == sportId);
                sportRate = sportsRateIndex > -1 ? esportLiveRateSetting[sportsRateIndex] : {};
            }
            else {
                sportsRateIndex = isEmpty(esportPrematchRateSetting) ? -1 : esportPrematchRateSetting.findIndex(setting => setting.sportId == sportId);
                sportRate = sportsRateIndex > -1 ? esportPrematchRateSetting[sportsRateIndex] : {};
            }


            if (!isEmpty(sportRate) && sportRate.status && !isEmpty(sportRate.min) && !isEmpty(sportRate.max)) {
                return {
                    min: Number(sportRate.min),
                    max: Number(sportRate.max),
                }
            }
            else {
                return {}
            }
        }
    }, [pageInfo.gameType, sportPrematchRateSetting, sportLiveRateSetting, esportPrematchRateSetting, esportLiveRateSetting]);

    // getMatchInfo(gamelist);
    const sortedMarket = sortMarkets(gamelist, sportId);
    // console.log("gamelist=", gamelist,"=sportId=", sportId, "=sortedMarket=", sortedMarket)
    const matchInfo = getMatchInfo(sortedMarket);
    // console.log(matchInfo)
    const { key,
        FixtureId,
        sportImg,
        leagueName,
        locationName,
        imgPath,
        homeTeam,
        awayTeam,
        time,
        rateHome,
        rateDraw,
        rateAway,
        countMarket,
        liveScoreHome,
        liveScoreAway,
        marketIndex,
        liveState,
        marketName
    } = matchInfo

    const onShowMarkets = (FixtureId, key) => {
        if (!interiorShowMarket) {
            getMarketInfo(FixtureId)
            onActiveId(sortedMarket.key)
        }
        setShowMarkets(!showMarkets);
        onInteriorShowMarket(keyIndex);
        // console.log('showMarkets: ', showMarkets, getDate());
    }

    const getMarketInfo = (Id) => {
        let data = {
            sportType: pageInfo.sportType,
            gameType: pageInfo.gameType,
            fixtureId: Id
        }
        props.GetMarketInfo(data)
    }

    const setActiveId = key => {
        props.GetIframeUrl(sortedMarket.FixtureId)
        props.SetActiveId(key);
    };

    const onActiveId = key => {
        setActiveId(key);
    };

    const [nowHomeRate, setNowHomeRate] = useState(rateHome);
    const [nowDrawRate, setNowDrawRate] = useState(rateDraw);
    const [nowAwayRate, setNowAwayRate] = useState(rateAway);

    const setTimeHomRate = () => {
        setTimeout(() => {
            setNowHomeRate(rateHome);
        }, 4600)
    }

    const setTimeDrawRate = () => {
        setTimeout(() => {
            setNowDrawRate(rateDraw);
        }, 4600)
    }

    const setTimeAwayRate = () => {
        setTimeout(() => {
            setNowAwayRate(rateAway);
        }, 4600)
    }

    useEffect(() => {
        if (nowHomeRate !== rateHome) {
            setTimeHomRate();
        }
        if (nowDrawRate !== rateDraw) {
            setTimeDrawRate();
        }
        if (nowAwayRate !== rateAway) {
            setTimeAwayRate();
        }
    }, [gamelist]);

    useEffect(() => {
        clearTimeout(setTimeHomRate());
        clearTimeout(setTimeDrawRate());
        clearTimeout(setTimeAwayRate());
    }, [])

    const getImg = (e) => {
        e.target.src = "../images/248.jpg"
    }

    const checkBetted = (index) => {
        // console.log(bettedItems.findIndex(item => item.betId === bet.Id) >= 0)
        // console.log(index)
        let bet = getBet(index);
        if (isEmpty(bet)) return
        // console.log(bet)
        return bettedItems.findIndex(item => item.betId === bet.Id) >= 0;
    }

    const onBetItem = (index) => {
        setActiveId(key)
        // getMarketInfo(FixtureId);
        //   console.log(index)
        // debugger
        // console.log('---------------------------------',list,betItemList, originSportslist)
        // console.log(sortedMarket.Markets[marketIndex])
        if (isEmpty(sortedMarket.Markets[marketIndex])) return;
        const market = sortedMarket.Markets[marketIndex]
        // console.log(market)
        let betList = { data: sortedMarket.Markets[marketIndex].Providers[0].Bets, marketId: market.Id };
        let bet = getBet(index)
        // debugger
        // console.log(betList)
        // console.log(bet)


        const Fixture = sortedMarket.Fixture;
        const verifyId = betList.special;
        // console.log(bettedItems)
        if (!checkBetted(index)) {
            const result = props.AddOneBet({ index, market, Fixture, bet, betList });
            if (!result) return; // toastr.warning('배팅규정에 어긋납니다.');
        }
        else
            props.RemoveOneBet(bet.Id);

    }

    const getBet = (index) => {
        //   debugger
        //   console.log(sortedMarket)
        //   console.log(gamelist)
        if (isEmpty(sortedMarket.Markets[marketIndex])) return;
        let betList = { data: sortedMarket.Markets[marketIndex].Providers[0].Bets };
        // console.log(betList)
        let key = index;
        if (rateDraw === 'VS' && index === 2) key = 1;
        // console.log(key, rateDraw, index)
        switch (key) {
            case 0:
                return betList.data[0]

            case 1:
                return betList.data[1]

            case 2:
                return betList.data[2]

            default:
                break;
        }
    }

    let bets = !isEmpty(sortedMarket.Markets[marketIndex]) ? sortedMarket.Markets[marketIndex].Providers[0].Bets : [];

    let minRate = 1;
    let maxRate = 10;
    if (pageInfo.gameType === "live") {
        if (pageInfo.sportType === "esport") {
            minRate = !isEmpty(baselineSetting.eliveminrate) ? baselineSetting.eliveminrate : 1
            maxRate = !isEmpty(baselineSetting.eliveminrate) ? baselineSetting.elivemaxrate : 1
        }
        else {
            minRate = !isEmpty(baselineSetting.liveminrate) ? baselineSetting.liveminrate : 1
            maxRate = !isEmpty(baselineSetting.liveminrate) ? baselineSetting.livemaxrate : 1
        }
    }

    return (
        <div className="sport_title_wrap">
            <div className="sport_title">
                <div className="sport_league">
                    <div className="sport_date">
                        <div className="date_field">{dateFormation(time, 8).split(' ')[0]}</div>
                        <div className="date_field">{dateFormation(time, 8).split(' ')[1]}&nbsp;&nbsp;</div>
                    </div>
                    <div style={{display : 'flex', alignItems : 'center', justifyContent : 'center'}}>
                        &nbsp;&nbsp;
                        <img src={imgPath} alt="" style={{width:"40px", height:"25px"}}/>
                    </div>
                    <div className='league_field' style={{display : 'flex', alignItems : 'center', justifyContent : 'center'}}>
                        &nbsp;&nbsp;{leagueName}
                    </div>
                </div>
            </div>
            <div className="sport_title_list" >
                <ul className=" match-market-item"  >
                    <li className="sport_etc">{marketName}</li>
                    <li className={`match-game-item position-relative sport_team1 ${checkBetted(0) && "active"} ${((rateHome > nowHomeRate) && "rate_up_effect ")} ${((rateHome < nowHomeRate) && " rate_down_effect ")}`} onClick={() => onBetItem(0)}>
                        <span className="team_l col">{homeTeam}</span>
                        {/* <span className="rate-color">:{liveScoreHome}</span> */}
                        <span className="team_r">&nbsp;{rateHome}</span>
                        {
                            (!isEmpty(bets[0]) &&
                                !isEmpty(bets[0].Price) &&
                                !isEmpty(bets[0].Price[0])) &&
                            (
                                (bets[0].Price[0].status > 3) ||
                                (bets[0].Status == 10) ||
                                (!isEmpty(rateValue) &&
                                    ((rateHome > rateValue.max) || (rateHome < rateValue.min))
                                ) ||
                                ((fixedNumber(bets[0].Price[0].Price) < minRate) ||
                                    (fixedNumber(bets[0].Price[0].Price) == 1) ||
                                    (((pageInfo.gameType === "live") && fixedNumber(bets[0].Price[0].Price) > maxRate)))) &&
                            <div className="betting-block" style={{ display: "flex" }}>
                                <div className="lock">
                                    <span className="icon-lock "></span>
                                </div>
                            </div>
                        }
                    </li>
                    <li className={`match-game-item position-relative sport_tie ${(rateDraw !== "VS" && checkBetted(1)) && "active"} ${(rateDraw > nowDrawRate) && "rate_up_effect "} ${(rateDraw < nowDrawRate) && " rate_down_effect "}`}>{rateDraw !== "VS" ?
                        <Fragment>
                            <span className="tie_d font06" onClick={() => onBetItem(1)}>{rateDraw}</span>
                            {
                                rateDraw != "VS" &&
                                (!isEmpty(bets[0]) &&
                                    !isEmpty(bets[0].Price) &&
                                    !isEmpty(bets[0].Price[0])) &&
                                (
                                    (bets[1].Price[0].status > 3) ||
                                    (bets[1].Status == 10) ||
                                    (!isEmpty(rateValue) &&
                                        ((rateDraw > rateValue.max) || (rateDraw < rateValue.min))
                                    ) ||
                                    ((fixedNumber(bets[1].Price[0].Price) < minRate) ||
                                        (fixedNumber(bets[1].Price[0].Price) == 1) ||
                                        ((pageInfo.gameType === "live") && (fixedNumber(bets[1].Price[0].Price) > maxRate)))
                                ) &&
                                <div className="betting-block" style={{ display: "flex" }}>
                                    <div className="lock">
                                        <span className="icon-lock"></span>
                                    </div>
                                </div>
                            }
                        </Fragment>
                        : "VS"}</li>
                    <li className={`match-game-item position-relative sport_team2 ${checkBetted(2) && "active"} ${(rateAway > nowAwayRate) && "rate_up_effect "} ${(rateAway < nowAwayRate) && " rate_down_effect "}`} onClick={() => onBetItem(2)}>
                        <span className="away_team_l">{rateAway}&nbsp;</span>
                        {/* <span className="rate-color">{liveScoreAway}:</span> */}
                        <span className="away_team_r col">{awayTeam}</span>
                        {
                          
                          (
                            (bets.length == 3) ? 
                                    ((!isEmpty(bets[2]) && 
                                    !isEmpty(bets[2].Price) && 
                                    !isEmpty(bets[2].Price[0])))
                                : 
                                    (!isEmpty(bets[1]) && 
                                    !isEmpty(bets[1].Price) && 
                                    !isEmpty(bets[1].Price[0]))
                        ) && 
                        (
                            (
                                (bets.length == 3) ? 
                                    (
                                        ((bets[2].Price[0].status > 3) || (bets[2].Status == 10 )) || 
                                        (!isEmpty(rateValue) &&
                                            ((rateHome > rateValue.max) || (rateHome < rateValue.min))
                                        ) ||
                                        ((fixedNumber(bets[2].Price[0].Price) < minRate) ||
                                        (fixedNumber(bets[2].Price[0].Price) == 1) ||
                                        ((pageInfo.gameType === "live") && (fixedNumber(bets[2].Price[0].Price) > maxRate)))
                                    )
                                : (
                                    (bets[1].Price[0].status > 3) || (bets[1].Status == 10 )) ||
                                    (!isEmpty(rateValue) &&
                                        ((rateHome > rateValue.max) || (rateHome < rateValue.min))
                                    ) ||
                                    ((fixedNumber(bets[1].Price[0].Price) < minRate) ||
                                    (fixedNumber(bets[1].Price[0].Price) == 1) ||
                                    ((pageInfo.gameType === "live") && (fixedNumber(bets[1].Price[0].Price) > maxRate)))
                            ) ||
                            (!isEmpty(rateValue) && 
                              ((rateAway > rateValue.max) || (rateAway < rateValue.min))
                            )
                        ) && 
                        <div className="betting-block" style={{ display: "flex" }}>
                            <div className="lock">
                                <span className="icon-lock"></span>
                            </div>
                        </div>
                        }
                    </li>
                    <li className="sport_more" onClick={() => onShowMarkets(FixtureId, keyIndex)}>+{countMarket}</li>
                </ul>
            </div>
        </div>
    )
};

const mapStateToProps = state => ({
    sports: state.sports,
    bettedItems: state.bet.bettedItems,
    bet: state.bet,
    baselineSetting: state.sports.baselineSetting,
    pageInfo: state.page.pageInfo
});

export default connect(mapStateToProps, { SetActiveId, AddOneBet, RemoveOneBet, GetIframeUrl, GetMarketInfo })(Match);


// WEBPACK FOOTER //
// ./src/components/sports/Match.js